import { v4 as uuidv4 } from 'uuid';

/**
 * 認証トークン用の文字列を作成する
 */
export const createAuthorizationTokenString = () => uuidv4();
